import React, { useState } from 'react';
import { useTranslations } from 'hooks/useTranslations';
import { StyledPageTitle } from 'theme/styles';
import Breadcrumbs from 'components/atoms/Breadcrumbs';
import { ERouteLinks } from 'models/route';
import { useNavigate } from 'react-router-dom';
import LicenceAuthorityForm from '../LicenceAuthorityForm';
import { ILicenceAuthorityFormValues } from 'models/licenceAuthority';
import { initialFormValues } from '../helpers';
import { useLicenceAuthorities } from '../hooks';

const LicenceAuthorityCreatePage = () => {
  const { t } = useTranslations();
  const navigate = useNavigate();
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);
  const { addLicenceAuthority } = useLicenceAuthorities();

  const onSubmit = async (data: ILicenceAuthorityFormValues) => {
    setIsSubmitLoading(true);
    const id = await addLicenceAuthority(data);
    if (id) {
      navigate(ERouteLinks.DetailsLicenceAuthorities.replace(':id', id));
    }
    setIsSubmitLoading(false);
  };

  return (
    <>
      <Breadcrumbs
        items={[
          { label: t('module.administration.name'), route: ERouteLinks.Administration },
          { label: t('licenceAuthorities.header'), route: ERouteLinks.LicenceAuthorities },
          t('licenceAuthorities.addNewLicenceAuthority.header'),
        ]}
      />
      <StyledPageTitle variant="h4">
        {t('licenceAuthorities.addNewLicenceAuthority.header')}
      </StyledPageTitle>

      <LicenceAuthorityForm
        isSubmitLoading={isSubmitLoading}
        onSubmit={onSubmit}
        initialFormValues={initialFormValues}
      />
    </>
  );
};

export default LicenceAuthorityCreatePage;
